const state = {
  ufContratoSelecionado: []
}

const mutations = {
  setUfContratoSelecionado (state, obj) {
    state.ufContratoSelecionado = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ufContratoSelecionado.js